import { Component } from '@angular/core';

@Component({
  selector: 'app-home-icon',
  templateUrl: './home-icon.component.html',
  styleUrl: './home-icon.component.scss',
})
export class HomeIconComponent {}
